import Axios from "axios";
import * as constant from "../constant.module.json";
const axios = Axios.create({
  baseURL: constant.baseURLOpp,
  // baseURL: constant.TestBaseUrl,
  headers: {
    "Content-type": "application/json",
  },

  // timeout: 60000,
});
export default axios;
